import { Injectable } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

@Injectable()
export class AppConfig {
  static appsettings: AppSettings;
}

export class AppSettings {
  apiRoot: string;
  navigatorRoot: string;
  redirectUrl: string;
  gtmcode: string;
  token: string;
  apiUrl: string;
  tenantId: string;
}

const BlueAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

export const appConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: BlueAura
      }
    })
  ]
};

